import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@fluentui/react-components';
import { InfoItemDefault } from './info-item-default';
import { InfoItemRename } from './info-item-rename';
import { useItemInfoContentStyles } from '../../styles';

export const ItemInfoContentBase = ({
  i18n,
  isReadonly,
  itemName,
  renameAsync,
  promptNameInputLabel,
  nameInputPlaceholderText,
  renameTitleText,
  itemInfos,
}) => {
  const classes = useItemInfoContentStyles();
  const renderItem = useCallback(({
    name, value, CustomComponent, CustomComponentOptions = {},
  }) => {
    if (CustomComponent) {
      return <CustomComponent {...CustomComponentOptions} />;
    }
    return <InfoItemDefault name={name} value={value} />;
  }, []);

  return (
    <div className={classes.contentBox}>
      <InfoItemRename
        i18n={i18n}
        isReadonly={isReadonly}
        name={itemName || ''}
        renameAsync={renameAsync}
        renderBlocker={({ spinnerStyle }) => <Spinner style={spinnerStyle} size="tiny" />}
        promptInputLabel={promptNameInputLabel}
        inputPlaceholderText={itemName ? '' : nameInputPlaceholderText}
        renameTitleText={renameTitleText}
      />
      <div className={classes.detailContentWrapper}>
        {
          itemInfos.map(({
            key,
            name, value,
            CustomComponent, CustomComponentOptions = {},
            valid = true,
          }) => (
            valid &&
              <React.Fragment key={key || name}>
                { renderItem({
                    name, value, CustomComponent, CustomComponentOptions,
                  })
                }
              </React.Fragment>
          ))
        }
      </div>
    </div>
  );
};

ItemInfoContentBase.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  isReadonly: PropTypes.bool,
  itemName: PropTypes.string,
  renameAsync: PropTypes.func.isRequired,
  promptNameInputLabel: PropTypes.string,
  nameInputPlaceholderText: PropTypes.string,
  itemInfos: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    url: PropTypes.string,
    copyUrl: PropTypes.func,
  })).isRequired,
};

ItemInfoContentBase.defaultProps = {
  isReadonly: false,
  itemName: null,
  promptNameInputLabel: '',
  nameInputPlaceholderText: '',
};
